import React, { useEffect, useRef } from 'react'
import FlashType from './FlashType'
import styles from './Flash.module.scss'

type FlashCloseHandler = (property: 'success'|'notice'|'alert'|'error') => void;

interface FlashProps {
  flash: FlashType;
  onClose?: FlashCloseHandler;
}

const Flash: React.FC<FlashProps> = (props: FlashProps) => {
  const successAlertRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!props.flash.success) return undefined

    const timerId = window.setTimeout(() => {
      successAlertRef.current?.classList.remove('show')
    }, 5000)

    return () => window.clearTimeout(timerId)
  }, [props.flash.success])

  const renderInternal = (property: 'success'|'notice'|'alert'|'error', className: string) => {
    const message = props.flash[property]

    // return nullだと存在しない要素に対しての操作でエラーになる場合があるので、<div />を返す
    if (!message) return <div />

    const handleClose = (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault()

      event.currentTarget.closest('.show')?.classList.remove('show')
    }

    const handleTransitionEnd = (event: React.TransitionEvent<HTMLDivElement>) => {
      event.preventDefault()

      if (props.onClose) {
        props.onClose(property)
      }
    }

    return (
      <div
        ref={property === 'success' ? successAlertRef : undefined}
        className={`alert alert-dismissible fade show flash-alert ${className}`}
        role="alert"
        onTransitionEnd={handleTransitionEnd}
      >
        <div className="container">
          <p className="alert-text" dangerouslySetInnerHTML={{ __html: message }} />
          <p className="alert-button">
            <button type="button" data-bs-dismiss="alert" aria-label="Close" onClick={handleClose}>&times;</button>
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.flashContainer}>
      { renderInternal('success', '-success') }
      { renderInternal('notice', '-success') }
      { renderInternal('alert', '-error') }
      { renderInternal('error', '-error') }
    </div>
  )
}


export { Flash, FlashProps, FlashCloseHandler }
